import { useState, useEffect } from 'react';
import screenerApi, { ScreenerStockResponse } from '../services/screenerApi.ts';
import { SCREENER_HISTORY_PAGE_SIZE } from '../constants/screener.ts';

interface ScreenerHistoryResult {
    data: ScreenerStockResponse[];
    loading: boolean;
    error: string | null;
    currentPage: number;
    totalPages: number;
    totalItems: number;
    setCurrentPage: (page: number) => void;
}

const useScreenerHistory = (screenerCode: string): ScreenerHistoryResult => {
    const [data, setData] = useState<ScreenerStockResponse[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        const fetchHistory = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await screenerApi.getHistory(screenerCode, currentPage, SCREENER_HISTORY_PAGE_SIZE);
                setData(response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalItems(response.data.totalElements);
            } catch (err: any) {
                setError(err.response?.data?.message || 'Failed to fetch history data');
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, [screenerCode, currentPage]);

    return { data, loading, error, currentPage, totalPages, totalItems, setCurrentPage };
};

export default useScreenerHistory;
